import sanitizeHtml from 'sanitize-html';
import {CSSProperties, useMemo} from "react";

export const SanitizedHtml = ({html, style}: { html: string, style?: CSSProperties }) => {
    const clean = useMemo(() => sanitizeHtml(html), [html]);
    return (
        <div style={style} dangerouslySetInnerHTML={{__html: clean}}/>
    );
};